<script>
/**
 * 合同项展示组件
 * 用于展示单个合同的信息
 */
export default {
  name: 'ContractItem',
  props: {
    // 合同数据对象
    contract: {
      type: Object,
      required: true
    },
    // 是否激活状态（选中状态）
    active: {
      type: Boolean,
      default: false
    },
    // 是否可点击
    clickable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handleClick() {
      if (this.clickable) {
        this.$emit('click', this.contract)
      }
    }
  }
}
</script>

<template>
  <div
    class="contract-item padding-sm"
    :class="{
      'active': active,
      'cursor': clickable
    }"
    @click="handleClick"
  >
    <div class="flex justify-between">
      <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
        <span class="text-bold" style="color: var(--color-text-1);">{{ contract.contractTitle }}</span>
        <span class="text-xs" style="display: inline-block;margin-left: 10px;">{{ contract.signDate }}</span>
        <el-tag class="margin-left-sm" v-if="contract.tmpFlag">临时</el-tag>
      </div>
      <div style="white-space: nowrap;">
        <span class="label">甲：</span>
        <span>{{ contract.partyAName }}</span>
      </div>
    </div>
    <div class="flex justify-between margin-top-xs">
      <div>
        <span class="label">合同号：</span>
        <span>{{ contract.contractNo }}</span>
      </div>
      <div style="white-space: nowrap;">
        <template v-if="contract.businessType === $enums.CONTRACT_BUSINESS_TYPE.SHIP.value">
          <span class="label">乙/船：</span>
          <span>{{ contract.partyBName || '-' }}</span>
          /
          <span>{{ contract.shipName || '-' }}</span>
        </template>
        <template v-else>
          <span class="label">乙：</span>
          <span>{{ contract.partyBName }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.contract-item {
  background: var(--color-fill-2);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  transition: all 0.2s;

  &:hover {
    background: var(--color-fill-3);
  }

  &.active {
    background: var(--color-primary-light-9);
    border: 1px solid var(--color-primary);
  }

  &.active::after {
    content: '';
    position: absolute;
    top: -1.7em;
    left: -1.7em;
    width: 3.5em;
    height: 3.5em;
    transform: rotate(45deg);
    background: var(--color-success);
  }
  &.active::before {
    content: '◉';
    position: absolute;
    top: 0.2em;
    left: 0.2em;
    color: var(--color-white);
    z-index: 1;
  }

  & ~ & {
    margin-top: 12px;
  }
}

.label {
  font-size: 12px;
  color: var(--color-text-3);
}
</style>

